import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTooltip = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.41406 3.08464H6.58073V4.2513H5.41406V3.08464ZM5.41406 5.41797H6.58073V8.91797H5.41406V5.41797ZM5.9974 0.167969C2.7774 0.167969 0.164062 2.7813 0.164062 6.0013C0.164062 9.2213 2.7774 11.8346 5.9974 11.8346C9.2174 11.8346 11.8307 9.2213 11.8307 6.0013C11.8307 2.7813 9.2174 0.167969 5.9974 0.167969ZM5.9974 10.668C3.4249 10.668 1.33073 8.5738 1.33073 6.0013C1.33073 3.4288 3.4249 1.33464 5.9974 1.33464C8.5699 1.33464 10.6641 3.4288 10.6641 6.0013C10.6641 8.5738 8.5699 10.668 5.9974 10.668Z",
		fill: "#F7F7F7",
		fillOpacity: .8
	})
});
export { SvgTooltip as ReactComponent };
